import { ShieldCheck, Wrench, FlaskConical, Fuel } from 'lucide-react';

export default function ServiceWarranty({ brand }) {
  return (
    <section className="max-w-5xl mx-auto my-5 px-4 py-8 space-y-8 rounded-xl shadow-lg bg-white">
      <div className="flex items-center justify-center gap-2 ">
        <ShieldCheck className="w-7 h-7 text-orange-600" />
        <h2 className="text-2xl md:text-3xl font-bold uppercase text-center">
          Service Warranty
        </h2>
      </div>

      <div className="text-gray-700 text-base leading-7 text-center max-w-3xl mx-auto">
        <p>
          Enjoy comprehensive <strong>workmanship warranty coverage</strong> with every {brand} aircon service. We&apos;re committed to quality and stand behind our work, so you can stay cool and worry-free.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 text-center text-sm md:text-base text-gray-800">
        {/* General Servicing */}
        <div className="bg-gray-50 rounded-lg shadow p-4 space-y-3 hover:shadow-md transition-all duration-300">
          <div className="flex justify-center text-orange-600">
            <Wrench className="w-6 h-6" />
          </div>
          <h3 className="font-semibold text-lg">General Servicing</h3>
          <p>
            Includes air filter cleaning and performance check-up for your {brand} unit.
          </p>
          <p className="font-medium text-amber-700">30 Days Workmanship Warranty</p>
        </div>

        {/* Chemical Service */}
        <div className="bg-gray-50 rounded-lg shadow p-4 space-y-3 hover:shadow-md transition-all duration-300">
          <div className="flex justify-center text-orange-600">
            <FlaskConical className="w-6 h-6" />
          </div>
          <h3 className="font-semibold text-lg">Chemical Cleaning</h3>
          <p>
            Deep cleaning to remove mold, dust, and buildup from {brand} indoor and outdoor units.
          </p>
          <p className="font-medium text-amber-700">60 Days Workmanship Warranty</p>
        </div>

        {/* Gas Refill */}
        <div className="bg-gray-50 rounded-lg shadow p-4 space-y-3 hover:shadow-md transition-all duration-300">
          <div className="flex justify-center text-orange-600">
            <Fuel className="w-6 h-6" />
          </div>
          <h3 className="font-semibold text-lg">Gas Refill</h3>
          <p>
            Top-up of {brand} aircon refrigerant gas (R22 / R410A / R32) for optimal cooling efficiency.
          </p>
          <p className="font-medium text-amber-700">90 Days Workmanship Warranty</p>
        </div>
      </div>
    </section>
  );
}
